/* Olfé landingspagina's (olfe-lp-*): video-slots, variantkeuze, winkelwagen, sticky bar.
   Geen framework. Werkt samen met de bestaande cart drawer van het thema (cart:refresh). */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var products = {};       // handle -> { data, state, listeners }
  var mediaObserver = null;
  var syncGroups = {};     // naam -> [media-elementen]

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var fmt = (window.theme && theme.settings && theme.settings.moneyFormat) || '€{{amount_with_comma_separator}}';
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return String(theme.Currency.formatMoney(cents, fmt)).replace(/<[^>]*>/g, '');
    }
    var v = (cents / 100).toFixed(2);
    fmt = fmt.replace(/<[^>]*>/g, '');
    return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, v.replace('.', ','));
  }

  function scrollToEl(el) {
    if (!el) return;
    el.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
  }

  /* ------------------------------------------------------------------ */
  /* Video's                                                            */
  /* ------------------------------------------------------------------ */

  function videoOf(m) { return m.querySelector('video'); }
  function embedOf(m) { return m.querySelector('.olfe-lp-media__embed'); }

  function startEmbed(m, src) {
    var holder = embedOf(m);
    if (!holder) return;
    var url = src || holder.getAttribute('data-embed-src');
    if (holder.firstChild && holder.firstChild.getAttribute('src') === url) return;
    holder.innerHTML = '';
    var f = document.createElement('iframe');
    f.src = url;
    f.title = holder.getAttribute('data-embed-title') || 'Video';
    f.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
    f.setAttribute('allowfullscreen', '');
    f.loading = 'lazy';
    holder.appendChild(f);
    m.classList.add('is-started', 'is-playing');
  }

  function stopEmbed(m) {
    var holder = embedOf(m);
    if (holder) holder.innerHTML = '';
    m.classList.remove('is-started', 'is-playing');
  }

  function playMedia(m, opts) {
    opts = opts || {};
    var v = videoOf(m);
    if (v) {
      if (opts.restart) { try { v.currentTime = 0; } catch (e) {} }
      var p = v.play();
      m.classList.add('is-started');
      if (p && p.then) {
        p.then(function () { m.classList.add('is-playing'); }).catch(function () { m.classList.remove('is-playing'); });
      } else {
        m.classList.add('is-playing');
      }
    } else if (embedOf(m)) {
      startEmbed(m);
    }
  }

  function pauseMedia(m) {
    var v = videoOf(m);
    if (v) { v.pause(); m.classList.remove('is-playing'); }
    else if (embedOf(m) && m.getAttribute('data-playback') === 'loop') { stopEmbed(m); }
  }

  function pauseOtherClickMedia(except) {
    $$('[data-lp-media][data-playback="click"]').forEach(function (m) {
      if (m === except) return;
      var v = videoOf(m);
      if (v) { v.pause(); m.classList.remove('is-playing'); }
      else if (embedOf(m)) { stopEmbed(m); }
    });
  }

  function isLoop(m) { return m.getAttribute('data-playback') !== 'click'; }

  function onMediaIntersect(entries) {
    entries.forEach(function (entry) {
      var m = entry.target;
      m._lpVisible = entry.isIntersecting;
      var group = m.getAttribute('data-sync');

      if (!isLoop(m)) {
        if (!entry.isIntersecting) pauseMedia(m);
        return;
      }
      if (reduceMotion.matches) return;

      if (group && syncGroups[group] && syncGroups[group].length > 1) {
        var members = syncGroups[group];
        var allVisible = members.every(function (x) { return x._lpVisible; });
        if (allVisible && !members._running) {
          members._running = true;
          members.forEach(function (x) { playMedia(x, { restart: true }); });
        } else if (!entry.isIntersecting && members._running) {
          members._running = false;
          members.forEach(pauseMedia);
        }
        return;
      }

      if (entry.isIntersecting) playMedia(m); else pauseMedia(m);
    });
  }

  function openFullscreen(m) {
    var dialog = document.createElement('div');
    dialog.className = 'lp-video-dialog';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-label', 'Video');

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'lp-video-dialog__close';
    close.setAttribute('aria-label', str('close', 'Sluiten'));
    close.textContent = '×';

    var src = videoOf(m);
    var player;
    if (src) {
      player = document.createElement('video');
      player.controls = true;
      player.playsInline = true;
      player.setAttribute('playsinline', '');
      $$('source', src).forEach(function (s) { player.appendChild(s.cloneNode()); });
      $$('track', src).forEach(function (t) {
        var c = t.cloneNode();
        c.default = true;
        c.setAttribute('default', '');
        player.appendChild(c);
      });
      if (src.getAttribute('poster')) player.poster = src.getAttribute('poster');
    } else {
      var holder = embedOf(m);
      var url = (holder.getAttribute('data-embed-src') || '')
        .replace('mute=1', 'mute=0').replace('muted=1', 'muted=0')
        .replace('controls=0', 'controls=1').replace('background=1', 'autoplay=1');
      player = document.createElement('iframe');
      player.src = url;
      player.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
      player.setAttribute('allowfullscreen', '');
    }

    var lastFocus = document.activeElement;
    function shut() {
      if (player.pause) player.pause();
      dialog.remove();
      document.removeEventListener('keydown', onKey);
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) { if (e.key === 'Escape') shut(); }

    close.addEventListener('click', shut);
    dialog.addEventListener('click', function (e) { if (e.target === dialog) shut(); });
    document.addEventListener('keydown', onKey);

    dialog.appendChild(player);
    dialog.appendChild(close);
    document.body.appendChild(dialog);
    document.documentElement.style.overflow = 'hidden';
    close.focus();

    if (player.play) {
      player.muted = false;
      var p = player.play();
      if (p && p.catch) p.catch(function () {});
      if (player.textTracks && player.textTracks[0]) player.textTracks[0].mode = 'showing';
    }
  }

  function onMediaClick(e) {
    var m = e.currentTarget;
    if (m.hasAttribute('data-fullscreen')) { e.preventDefault(); openFullscreen(m); return; }

    if (!isLoop(m)) {
      var v = videoOf(m);
      if (v) {
        if (!v.paused && e.target === v) return; // native controls doen de rest
        if (m.classList.contains('is-playing')) return;
        pauseOtherClickMedia(m);
        v.muted = false;
        v.controls = true;
        playMedia(m);
      } else if (embedOf(m) && !m.classList.contains('is-started')) {
        pauseOtherClickMedia(m);
        startEmbed(m);
      }
      return;
    }

    // Loop-slot met reduced motion: tik = afspelen/pauzeren (stil).
    if (reduceMotion.matches && e.target.closest('.olfe-lp-media__play--rm, video, img')) {
      if (m.classList.contains('is-playing')) pauseMedia(m); else playMedia(m);
    }
  }

  function initMedia(root) {
    if (!mediaObserver && 'IntersectionObserver' in window) {
      mediaObserver = new IntersectionObserver(onMediaIntersect, { threshold: 0.25 });
    }
    $$('[data-lp-media]', root).forEach(function (m) {
      if (m._lpInit) return;
      m._lpInit = true;
      if (reduceMotion.matches) m.classList.add('is-reduced');

      var v = videoOf(m);
      if (v) {
        v.addEventListener('play', function () { m.classList.add('is-playing', 'is-started'); if (!isLoop(m)) pauseOtherClickMedia(m); });
        v.addEventListener('pause', function () { m.classList.remove('is-playing'); });
      }

      var group = m.getAttribute('data-sync');
      if (group) {
        syncGroups[group] = (syncGroups[group] || []).filter(function (x) { return document.contains(x); });
        syncGroups[group].push(m);
      }

      m.addEventListener('click', onMediaClick);
      if (mediaObserver) mediaObserver.observe(m);
      else if (isLoop(m) && !reduceMotion.matches) playMedia(m);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Product, varianten, bundels, set-producten en winkelwagen          */
  /* ------------------------------------------------------------------ */

  var buys = {};         // handle -> koop-sectie (bundel, extra leggings, set-producten)
  var cartTotal = null;  // centen in de winkelwagen

  function str(key, fallback) {
    return (window.olfeLp && olfeLp.strings && olfeLp.strings[key]) || fallback;
  }

  function getProduct(handle) {
    if (products[handle]) return products[handle];
    var script = document.querySelector('script[data-lp-product="' + handle + '"]');
    if (!script) return null;
    var data;
    try { data = JSON.parse(script.textContent); } catch (e) { return null; }
    var p = { handle: handle, data: data, state: { color: matchColor(data, data.defaultColor), size: null } };
    products[handle] = p;
    return p;
  }

  // Kleurnaam uit een instelling omzetten naar de echte optiewaarde (hoofdletterongevoelig).
  function matchColor(data, wanted) {
    var idx = data.colorIndex;
    if (idx < 0) return null;
    var w = String(wanted || '').toLowerCase().trim();
    var hit = null;
    data.options[idx].values.forEach(function (val) { if (!hit && w && val.toLowerCase() === w) hit = val; });
    if (hit) return hit;
    var firstAvail = data.variants.filter(function (v) { return v.available; })[0] || data.variants[0];
    return firstAvail.options[idx];
  }

  function variantFor(p, color, size) {
    var d = p.data;
    return d.variants.filter(function (v) {
      if (d.colorIndex > -1 && v.options[d.colorIndex] !== color) return false;
      if (d.sizeIndex > -1 && v.options[d.sizeIndex] !== size) return false;
      return true;
    })[0] || null;
  }

  function anyVariantForColor(p, color) {
    var d = p.data;
    var list = d.variants.filter(function (v) { return d.colorIndex < 0 || v.options[d.colorIndex] === color; });
    return list.filter(function (v) { return v.available; })[0] || list[0] || d.variants[0];
  }

  function itemVariant(p, item) {
    if (p.data.sizeIndex < 0) return anyVariantForColor(p, item.color);
    return item.size ? variantFor(p, item.color, item.size) : null;
  }

  function itemPrice(p, item) {
    var v = itemVariant(p, item) || anyVariantForColor(p, item.color);
    return v ? v.price : 0;
  }

  function currentVariant(p) { return itemVariant(p, p.state); }
  function priceVariant(p) { return currentVariant(p) || anyVariantForColor(p, p.state.color); }
  function needsSize(p) { return p.data.sizeIndex > -1 && !p.state.size; }

  function addonProduct(a) { return getProduct(a.handle); }
  function addonVariant(a) {
    var ap = addonProduct(a);
    if (!ap) return null;
    return itemVariant(ap, { color: a.color, size: a.size });
  }
  function addonPrice(a) {
    var ap = addonProduct(a);
    if (!ap) return 0;
    var v = addonVariant(a) || anyVariantForColor(ap, a.color);
    return v ? v.price : 0;
  }

  function legsTotal(p, buy, qty) {
    var t = 0;
    for (var i = 0; i < qty; i++) t += itemPrice(p, buy.items[i] || p.state);
    if (qty >= 2 && buy.discount > 0) t = Math.round(t * (1 - buy.discount / 100));
    return t;
  }

  // Totaal van alles wat de klant nu gekozen heeft (leggings + set-producten).
  function selectionTotal(p) {
    var buy = buys[p.handle];
    if (!buy) return itemPrice(p, p.state);
    var t = legsTotal(p, buy, buy.qty);
    buy.addons.forEach(function (a) { if (a.on) t += addonPrice(a); });
    return t;
  }

  function colorImage(p) {
    var media = p.data.media || [];
    var key = p.data.colorHandles[(p.state.color || '').toLowerCase()];
    var hit = media.filter(function (m) { return m.color && m.color === key; })[0];
    var v = anyVariantForColor(p, p.state.color);
    return (hit && hit.thumb) || (v && v.image) || (media[0] && media[0].thumb) || '';
  }

  function sizeChartRow(size) {
    var script = $('script[data-lp-sizechart]');
    if (!script) return null;
    try {
      var rows = JSON.parse(script.textContent);
      return rows.filter(function (r) { return r.size.toLowerCase() === String(size).toLowerCase(); })[0] || null;
    } catch (e) { return null; }
  }

  function fillTemplate(tpl, map) {
    return String(tpl || '').replace(/\[([a-z_]+)\]/g, function (all, key) { return map[key] != null ? map[key] : ''; });
  }

  // Kleur- en maatknoppen van één legging of set-product bijwerken.
  function renderPicker(p, root, item) {
    var d = p.data;
    $$('[data-lp-color]', root).forEach(function (btn) {
      var val = btn.getAttribute('data-lp-color');
      btn.setAttribute('aria-pressed', val === item.color ? 'true' : 'false');
      btn.classList.toggle('is-soldout', !d.variants.some(function (x) { return x.options[d.colorIndex] === val && x.available; }));
    });
    $$('[data-lp-color-label]', root).forEach(function (el) { el.textContent = item.color || ''; });
    $$('[data-lp-size], [data-lp-addon-size]', root).forEach(function (btn) {
      var val = btn.getAttribute('data-lp-size') || btn.getAttribute('data-lp-addon-size');
      var match = variantFor(p, item.color, val);
      btn.hidden = !match;
      btn.classList.toggle('is-soldout', !!match && !match.available);
      btn.setAttribute('aria-disabled', match && match.available ? 'false' : 'true');
      btn.setAttribute('aria-pressed', val === item.size ? 'true' : 'false');
    });
    $$('[data-lp-size-label]', root).forEach(function (el) { el.textContent = item.size || el.getAttribute('data-empty') || ''; });
    $$('[data-lp-hint]', root).forEach(function (el) {
      var row = item.size ? sizeChartRow(item.size) : null;
      el.hidden = !row;
      if (row) el.textContent = fillTemplate(el.getAttribute('data-template'), { maat: row.size, eu: row.eu, taille: row.waist, heupen: row.hips });
    });
  }

  function renderBuy(p, buy) {
    var root = buy.root;
    var threshold = 0;
    var ship = $('[data-lp-ship]', root);
    if (ship) threshold = parseInt(ship.getAttribute('data-threshold'), 10) || 0;

    $$('[data-lp-bundle]', root).forEach(function (btn) {
      var q = parseInt(btn.getAttribute('data-lp-bundle'), 10);
      btn.setAttribute('aria-pressed', q === buy.qty ? 'true' : 'false');
      var price = legsTotal(p, buy, q);
      var priceEl = $('[data-lp-bundle-price]', btn);
      if (priceEl) priceEl.textContent = formatMoney(price);
      var free = $('[data-lp-bundle-free]', btn);
      if (free) free.hidden = !(threshold && price >= threshold);
    });

    $$('[data-lp-item]', root).forEach(function (el) {
      var i = parseInt(el.getAttribute('data-lp-item'), 10);
      el.hidden = i >= buy.qty;
      var title = $('[data-lp-item-title]', el);
      if (title) title.hidden = buy.qty < 2;
      if (i < buy.qty) renderPicker(p, el, buy.items[i]);
    });

    buy.addons.forEach(function (a) {
      var ap = addonProduct(a);
      $('[data-lp-addon-toggle]', a.el).setAttribute('aria-pressed', a.on ? 'true' : 'false');
      a.el.classList.toggle('is-on', a.on);
      var sizes = $('[data-lp-addon-sizes]', a.el);
      if (sizes) sizes.hidden = !a.on;
      if (ap) {
        renderPicker(ap, a.el, a);
        var priceEl = $('[data-lp-addon-price]', a.el);
        if (priceEl) priceEl.textContent = formatMoney(addonPrice(a));
      }
    });

    if (ship) {
      var base = cartTotal != null ? cartTotal : (parseInt(ship.getAttribute('data-cart-total'), 10) || 0);
      var total = base + selectionTotal(p);
      var left = Math.max(0, threshold - total);
      $('[data-lp-ship-text]', ship).textContent = left > 0
        ? fillTemplate(ship.getAttribute('data-text-remaining'), { bedrag: formatMoney(left) })
        : ship.getAttribute('data-text-free');
      $('[data-lp-ship-fill]', ship).style.width = Math.min(100, threshold ? total / threshold * 100 : 100) + '%';
      ship.classList.toggle('is-free', left === 0);
    }
  }

  function render(p) {
    var v = priceVariant(p);
    var price = v ? formatMoney(v.price) : '';
    var compare = v && v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : '';
    var pct = v && v.compare_at_price > v.price ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0;
    var img = colorImage(p);
    var colorName = p.state.color || '';
    var size = p.state.size;
    var total = formatMoney(selectionTotal(p));
    var buy = buys[p.handle];

    $$('[data-lp-for="' + p.handle + '"]').forEach(function (root) {
      $$('[data-lp-price]', root).forEach(function (el) { el.textContent = price; el.classList.toggle('lp-price-sale', !!compare); });
      $$('[data-lp-compare]', root).forEach(function (el) { el.textContent = compare; el.hidden = !compare; });
      $$('[data-lp-badge]', root).forEach(function (el) { el.textContent = '-' + pct + '%'; el.hidden = !pct; });
      $$('[data-lp-img]', root).forEach(function (el) { if (img && el.getAttribute('src') !== img) el.setAttribute('src', img); });

      $$('[data-lp-summary]', root).forEach(function (el) {
        var parts = [];
        if (colorName) parts.push(colorName);
        if (size) parts.push((el.hasAttribute('data-size-prefix') ? el.getAttribute('data-size-prefix') : '') + size);
        if (el.hasAttribute('data-with-price')) parts.push(total);
        el.textContent = parts.join(' · ');
      });

      // Galerij volgt de kleur van legging 1
      var thumbs = $$('[data-lp-thumb]', root);
      if (thumbs.length) {
        var colorKey = p.data.colorHandles[colorName.toLowerCase()];
        var visible = thumbs.filter(function (t) { var c = t.getAttribute('data-color'); return !c || !colorKey || c === colorKey; });
        if (!visible.length) visible = thumbs;
        thumbs.forEach(function (t) { t.hidden = visible.indexOf(t) < 0; });
        if (p._lastColor !== colorName) {
          thumbs.forEach(function (t) { t.setAttribute('aria-current', t === visible[0] ? 'true' : 'false'); });
          var main = $('[data-lp-main-img]', root);
          if (main && visible[0]) {
            main.src = visible[0].getAttribute('data-full');
            main.srcset = visible[0].getAttribute('data-srcset') || '';
          }
        }
      }

      $$('[data-lp-add], [data-lp-cta]', root).forEach(function (btn) { updateButtonLabel(p, btn); });
    });

    if (buy) renderBuy(p, buy);

    $$('[data-lp-chart-row]').forEach(function (tr) {
      tr.classList.toggle('is-active', !!size && tr.getAttribute('data-lp-chart-row').toLowerCase() === String(size).toLowerCase());
    });

    p._lastColor = colorName;
  }

  // Alleen producten met een eigen blok op de pagina (set-producten worden via hun koop-sectie bijgewerkt).
  function renderAll() {
    for (var k in products) {
      if (document.querySelector('[data-lp-for="' + k + '"]')) render(products[k]);
    }
  }

  function updateButtonLabel(p, btn) {
    if (btn.getAttribute('aria-busy') === 'true' || btn.classList.contains('is-added')) return;
    var label;
    var cv = currentVariant(p);
    if (needsSize(p) && btn.hasAttribute('data-lp-cta')) label = btn.getAttribute('data-label-choose');
    else if (cv && !cv.available) label = btn.getAttribute('data-label-soldout');
    else label = fillTemplate(btn.getAttribute('data-label-add'), { prijs: formatMoney(selectionTotal(p)) });
    ($('[data-lp-label]', btn) || btn).textContent = label;
  }

  function clearErrors(p) {
    $$('[data-lp-for="' + p.handle + '"] [data-lp-error], [data-lp-for="' + p.handle + '"] [data-lp-cart-error]').forEach(function (el) { el.hidden = true; });
  }

  function setItem(p, i, patch) {
    var buy = buys[p.handle];
    var item = i === 0 ? p.state : buy.items[i];
    for (var k in patch) item[k] = patch[k];
    if (patch.color && item.size && !variantFor(p, item.color, item.size)) item.size = null;
    clearErrors(p);
    render(p);
  }

  function setState(p, patch) { setItem(p, 0, patch); }

  function showError(p, msg, target) {
    var buy = buys[p.handle];
    var el = buy ? $('[data-lp-error]', buy.root) : null;
    if (el) { el.textContent = msg; el.hidden = false; }
    scrollToEl(target || (buy && buy.root));
  }

  // Controleert alle keuzes; geeft een melding + plek terug als er iets mist.
  function validate(p) {
    var buy = buys[p.handle];
    if (!buy) {
      if (needsSize(p)) return { msg: '', target: document.querySelector('[data-lp-for="' + p.handle + '"] [data-lp-sizes]') };
      return null;
    }
    for (var i = 0; i < buy.qty; i++) {
      var item = buy.items[i];
      var itemEl = $('[data-lp-item="' + i + '"]', buy.root);
      if (p.data.sizeIndex > -1 && !item.size) {
        return { msg: i === 0 ? buy.root.getAttribute('data-msg-size') : fillTemplate(buy.root.getAttribute('data-msg-size-n'), { n: i + 1 }), target: itemEl };
      }
      var v = itemVariant(p, item);
      if (!v || !v.available) return { msg: $('[data-lp-add]', buy.root).getAttribute('data-label-soldout'), target: itemEl };
    }
    for (var j = 0; j < buy.addons.length; j++) {
      var a = buy.addons[j];
      if (!a.on) continue;
      var ap = addonProduct(a);
      if (ap && ap.data.sizeIndex > -1 && !a.size) return { msg: a.el.getAttribute('data-msg'), target: a.el };
    }
    return null;
  }

  function cartLines(p) {
    var buy = buys[p.handle];
    var map = {}, order = [];
    function push(v) {
      if (!v) return;
      if (!map[v.id]) { map[v.id] = 0; order.push(v.id); }
      map[v.id] += 1;
    }
    if (!buy) { push(currentVariant(p)); }
    else {
      for (var i = 0; i < buy.qty; i++) push(itemVariant(p, buy.items[i]));
      buy.addons.forEach(function (a) { if (a.on) push(addonVariant(a)); });
    }
    return order.map(function (id) { return { id: id, quantity: map[id] }; });
  }

  function updateCartCount(cart) {
    cartTotal = cart.total_price;
    $$('[data-lp-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = !cart.item_count; });
  }

  function rootUrl() { return ((window.theme && theme.routes && theme.routes.root_url) || '/').replace(/\/$/, ''); }

  function addToCart(p, btn) {
    var problem = validate(p);
    if (problem) { showError(p, problem.msg, problem.target); return; }
    var items = cartLines(p);
    if (!items.length) return;

    var labelEl = $('[data-lp-label]', btn) || btn;
    clearErrors(p);
    btn.setAttribute('aria-busy', 'true');
    labelEl.textContent = btn.getAttribute('data-label-busy');

    fetch(rootUrl() + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || str('error', 'Er ging iets mis.'));
        return fetch(rootUrl() + '/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-added');
        labelEl.textContent = btn.getAttribute('data-label-added');
        setTimeout(function () { btn.classList.remove('is-added'); updateButtonLabel(p, btn); }, 1800);

        updateCartCount(cart);
        renderAll();
        try {
          if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'olfe-lp', productVariantId: items[0].id, cart: cart });
          }
        } catch (e) {}
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: { id: items[0].id, variant_id: items[0].id } } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        try {
          window._learnq = window._learnq || [];
          window._learnq.push(['track', 'Added to Cart', {
            total_price: cart.total_price / 100, $value: cart.total_price / 100,
            original_total_price: cart.original_total_price / 100, items: cart.items
          }]);
        } catch (e) {}
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        updateButtonLabel(p, btn);
        var buy = buys[p.handle];
        var el = buy ? $('[data-lp-cart-error]', buy.root) : null;
        if (el) { el.textContent = err.message; el.hidden = false; }
      });
  }

  function initBuy(scope, p) {
    if (buys[p.handle] && buys[p.handle].root === scope) return;
    var first = $('[data-lp-bundle]', scope);
    var buy = {
      root: scope,
      qty: first ? parseInt(first.getAttribute('data-lp-bundle'), 10) : 1,
      discount: parseInt(scope.getAttribute('data-bundle-discount'), 10) || 0,
      items: [p.state],
      addons: []
    };
    var second = matchColor(p.data, scope.getAttribute('data-second-color'));
    $$('[data-lp-item]', scope).forEach(function (el) {
      var i = parseInt(el.getAttribute('data-lp-item'), 10);
      if (i > 0) buy.items[i] = { color: second || p.state.color, size: null };
    });
    $$('[data-lp-addon]', scope).forEach(function (el) {
      var ap = getProduct(el.getAttribute('data-handle'));
      buy.addons.push({ el: el, handle: el.getAttribute('data-handle'), color: ap ? matchColor(ap.data, el.getAttribute('data-color')) : null, size: null, on: false });
    });
    buys[p.handle] = buy;
  }

  function onScopeClick(e) {
    var scope = e.currentTarget;
    var p = getProduct(scope.getAttribute('data-lp-for'));
    if (!p) return;
    var buy = buys[p.handle];

    var bundle = e.target.closest('[data-lp-bundle]');
    if (bundle && buy) {
      buy.qty = parseInt(bundle.getAttribute('data-lp-bundle'), 10);
      clearErrors(p);
      render(p);
      return;
    }

    var addonEl = e.target.closest('[data-lp-addon]');
    if (addonEl && buy) {
      var a = buy.addons.filter(function (x) { return x.el === addonEl; })[0];
      if (!a) return;
      if (e.target.closest('[data-lp-addon-toggle]')) { a.on = !a.on; }
      var as = e.target.closest('[data-lp-addon-size]');
      if (as) {
        if (as.getAttribute('aria-disabled') === 'true') return;
        a.size = as.getAttribute('data-lp-addon-size');
      }
      clearErrors(p);
      render(p);
      return;
    }

    var itemEl = e.target.closest('[data-lp-item]');
    var i = itemEl ? parseInt(itemEl.getAttribute('data-lp-item'), 10) : 0;

    var c = e.target.closest('[data-lp-color]');
    if (c) { setItem(p, i, { color: c.getAttribute('data-lp-color') }); return; }

    var s = e.target.closest('[data-lp-size]');
    if (s) {
      if (s.getAttribute('aria-disabled') === 'true') return;
      setItem(p, i, { size: s.getAttribute('data-lp-size') });
      return;
    }

    var t = e.target.closest('[data-lp-thumb]');
    if (t) {
      $$('[data-lp-thumb]', scope).forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      var main = $('[data-lp-main-img]', scope);
      if (main) { main.src = t.getAttribute('data-full'); main.srcset = t.getAttribute('data-srcset') || ''; }
      return;
    }

    var add = e.target.closest('[data-lp-add]');
    if (add) { e.preventDefault(); addToCart(p, add); return; }

    var cta = e.target.closest('[data-lp-cta]');
    if (cta) {
      e.preventDefault();
      if (needsSize(p)) {
        var target = document.getElementById(cta.getAttribute('data-target') || 'kopen');
        scrollToEl(target);
      } else {
        var mainBtn = buy ? $('[data-lp-add]', buy.root) : null;
        addToCart(p, cta);
        if (mainBtn) updateButtonLabel(p, mainBtn);
      }
    }
  }

  function initProducts(root) {
    $$('[data-lp-for]', root).forEach(function (scope) {
      if (scope._lpInit) return;
      scope._lpInit = true;
      var p = getProduct(scope.getAttribute('data-lp-for'));
      if (!p) return;
      if (scope.hasAttribute('data-lp-buy')) initBuy(scope, p);
      scope.addEventListener('click', onScopeClick);
    });
    renderAll();
  }

  /* ------------------------------------------------------------------ */
  /* Aanbevelingen (Shopify product recommendations)                    */
  /* ------------------------------------------------------------------ */

  function initRecs(root) {
    $$('[data-lp-recs][data-url]', root).forEach(function (sec) {
      if (sec._lpInit) return;
      sec._lpInit = true;
      var load = function () {
        fetch(sec.getAttribute('data-url'))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var track = doc.querySelector('[data-lp-recs-track]');
            var mine = $('[data-lp-recs-track]', sec);
            if (track && mine && track.children.length) mine.innerHTML = track.innerHTML;
            if (mine && !mine.children.length) sec.hidden = true;
          })
          .catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '600px 0px' });
        io.observe(sec);
      } else { load(); }
    });
    $$('[data-lp-recs]:not([data-url])', root).forEach(function (sec) {
      var mine = $('[data-lp-recs-track]', sec);
      if (mine && !mine.children.length && !(window.Shopify && Shopify.designMode)) sec.hidden = true;
    });
  }

  /* ------------------------------------------------------------------ */
  /* Header, ankers, UGC-pijlen, FAQ, sticky bar                        */
  /* ------------------------------------------------------------------ */

  function initChrome(root) {
    $$('a[href^="#"]', root).forEach(function (a) {
      if (a._lpInit) return;
      a._lpInit = true;
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var el = id && document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        scrollToEl(el);
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });

    $$('[data-lp-open-cart]', root).forEach(function (btn) {
      if (btn._lpInit) return;
      btn._lpInit = true;
      btn.addEventListener('click', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') { e.preventDefault(); drawer.show(btn); }
      });
    });

    $$('[data-lp-track]', root).forEach(function (track) {
      if (track._lpInit) return;
      track._lpInit = true;
      var section = track.closest('section') || root;
      $$('[data-lp-prev], [data-lp-next]', section).forEach(function (b) {
        b.addEventListener('click', function () {
          var item = track.firstElementChild;
          var step = item ? item.getBoundingClientRect().width + 14 : 300;
          track.scrollBy({ left: (b.hasAttribute('data-lp-prev') ? -1 : 1) * step, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        });
      });
    });

    $$('[data-lp-faq]', root).forEach(function (list) {
      if (list._lpInit) return;
      list._lpInit = true;
      list.addEventListener('toggle', function (e) {
        if (!e.target.open) return;
        $$('details', list).forEach(function (d) { if (d !== e.target) d.open = false; });
      }, true);
    });
  }

  var sticky = { bar: null, heroOut: false, buyIn: false, io: null };

  function updateSticky() {
    if (!sticky.bar) return;
    sticky.bar.classList.toggle('is-visible', sticky.heroOut && !sticky.buyIn);
    sticky.bar.setAttribute('aria-hidden', sticky.bar.classList.contains('is-visible') ? 'false' : 'true');
  }

  function initSticky() {
    var bar = $('[data-lp-sticky]');
    if (!bar || bar === sticky.bar) return;
    sticky.bar = bar;
    if (sticky.io) sticky.io.disconnect();
    if (!('IntersectionObserver' in window)) return;

    var hero = $('[data-lp-hero]');
    var buy = document.getElementById(bar.getAttribute('data-target') || 'kopen');
    sticky.heroOut = !hero;
    sticky.buyIn = false;

    sticky.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.target === hero) sticky.heroOut = !en.isIntersecting && en.boundingClientRect.top < 0;
        if (en.target === buy) sticky.buyIn = en.isIntersecting;
      });
      updateSticky();
    }, { threshold: 0 });
    if (hero) sticky.io.observe(hero);
    if (buy) sticky.io.observe(buy);
  }

  function initCartCount() {
    if (!$('[data-lp-cart-count]') && !$('[data-lp-ship]')) return;
    fetch(((window.theme && theme.routes && theme.routes.root_url) || '/').replace(/\/$/, '') + '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { updateCartCount(c); renderAll(); }).catch(function () {});
  }

  function initAll(root) {
    root = root || document;
    initMedia(root);
    initProducts(root);
    initChrome(root);
    initRecs(root);
    initSticky();
  }

  function boot() {
    initAll(document);
    initCartCount();
    // Bestaande cart drawer bijwerken als items daar worden aangepast.
    try {
      if (window.theme && theme.pubsub && theme.pubsub.subscribe) {
        theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (e) { if (e && e.cart && e.source !== 'olfe-lp') { updateCartCount(e.cart); renderAll(); } });
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Thema-editor: secties opnieuw initialiseren na wijzigen.
  document.addEventListener('shopify:section:load', function () {
    sticky.bar = null;
    initAll(document);
    renderAll();
  });
})();
